import script from "./PlLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./PlLogo.vue?vue&type=script&setup=true&lang=js"

import "./PlLogo.vue?vue&type=style&index=0&id=68082421&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68082421"]])

export default __exports__